import { createSelector } from 'reselect'
import { companyPreLiveStates, companyStateMap } from '../helpers/companyHelpers'
import { getHiringTeamMap } from '../reducks/hiringTeams'
import { getSessionView } from '../reducks/sessions'
import { hiringTeamId } from './currentUser'

export const sessionMetadata = createSelector([getSessionView], ({ companyState, unreadInterviewRequestCount }) => ({
  companyState,
  companyStateLabel: companyState === 'live' ? companyStateMap[companyState].label : 'Hidden',
  unreadInterviewRequestCount,
}))

export const hiringTeamsList = createSelector([getSessionView, getHiringTeamMap], ({ hiringTeams }, hiringTeamMap) =>
  hiringTeams.map(teamId => {
    const hiringTeam = hiringTeamMap[teamId]
    return {
      id: teamId,
      name: hiringTeam.name,
    }
  }),
)

export const currentHiringTeam = createSelector([hiringTeamId, getHiringTeamMap], (hiringTeamId, hiringTeamMap) => {
  const team = hiringTeamMap[hiringTeamId]
  if (!team) return {}
  const { id, currency_code: currencyCode, currency_symbol: currencySymbol, remuneration_period: remunerationPeriod, name, region } = team

  return {
    id,
    name,
    currencyCode,
    currencySymbol,
    remunerationPeriod,
    region: {
      id: region.id,
      code: region.code,
    },
  }
})

// Only check the last updated for metadata because we only need to know it has been stored once before
// Metadata gets reloaded (in interviewRequestDetails)

export const loadingCompany = createSelector(
  [getSessionView],
  view =>
    view.fetchingCompanyAccount ||
    !view.lastUpdatedCompanyAccount ||
    !view.lastUpdatedMetadata ||
    view.fetchingHiringTeams ||
    !view.lastUpdatedHiringTeams,
)

export const companyId = createSelector([getSessionView], view => view.companyId)

export const greenhouseEnabled = createSelector([getSessionView], view => view.greenHouseIntegration)

export const companyState = createSelector([getSessionView], view => view.companyState)

export const companyLiveOrDormant = createSelector([companyState], state => ['live', 'dormant'].indexOf(state) >= 0)

export const companyDormant = createSelector([companyState], state => state === 'dormant')

export const companyPreLive = createSelector([companyState], state => companyPreLiveStates.indexOf(state) >= 0)

export const companyLive = createSelector([companyState], state => state === 'live')
